import { Component, Input } from '@angular/core';

/**
 * The brand loader. Used wherever a page is waiting on data, so every surface
 * shows the same thing instead of its own line of text.
 */
@Component({
  selector: 'ks-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  /** Announced to screen readers and shown under the mark. */
  @Input() label = 'Loading…';
  /** `inline` for a small mark beside content, `block` for a full panel. */
  @Input() size: 'block' | 'inline' = 'block';
}
